import { filterData } from "../../../../../helpers/filterHelper";
import { store } from "../../../../../config/store";
import { showToastError, showMessageApi } from "../../../../Main/actions";
import trace from "../../../../../helpers/trace";
import { getPrestaciones, getPrestacion, deletePrestacion, createPrestacion, updatePrestacion } from "../../../../../services/mantenedoresSelApi";


export const loading = (isLoading) => ({
  type: "LOADING_MANTENEDOR_PRESTACIONES_SEL",
  isLoading,
});

export const setListaPrestacionesSel = (data) => ({
  type: "SET_LISTA_PRESTACIONES_SEL",
  data,
});

export const setFiltrosPrestacionesSel = (filtros) => ({
  type: "SET_FILTROS_PRESTACIONES_SEL",
  filtros,
});

export const setPrestacionSel = (data) => ({
  type: "SET_PRESTACION_SEL",
  data,
});

export const setListaPrestacionesSelFiltradas = (data) => ({
  type: "SET_LISTA_PRESTACIONES_SEL_FILTRADAS",
  data,
});

export const openCloseModalDesactivarPrestacionSel = (isOpen, selectedPrestacion) => ({
  type: "OPEN_CLOSE_MODAL_DESACTIVAR_PRESTACION_SEL",
  isOpen,
  selectedPrestacion,
});

export const openCloseModalEditarPrestacionesSel = (isOpen, selectedPrestacion, isNew) => ({
  type: "OPEN_CLOSE_MODAL_EDITAR_PRESTACIONES_SEL",
  isOpen,
  selectedPrestacion,
  isNew,
});

export const openCloseModalEliminarPrestacionSel = (isOpen, selectedPrestacion) => ({
  type: "OPEN_CLOSE_MODAL_ELIMINAR_PRESTACION_SEL",
  isOpen,
  selectedPrestacion,
});

export const doGetPrestacionById = (prestacion) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;
    const request = await getPrestacion(prestacion.Id);
    if (request.status === 200) {
      const result = await request.json();
      const data = { ...result };
      dispatch(openCloseModalEditarPrestacionesSel(true, data, false));
      dispatch(showMessageApi(message, request));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doGetPrestacionData", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};


export const doGetFiltrosPrestacionesPes = () => async (dispatch) => {
  dispatch(loading(true));
  try {
    const filtros = [
      {
        column: "Status",
        name: "Activo",
        type: "bool",
        values: [
          { value: 1, text: "Si" },
          { value: 0, text: "No" },
        ],
      },
      {
        column: "ExamTypeId",
        name: "Tipo",
        type: "bool",
        values: [
          { value: 1, text: "SEP" },
          { value: 2, text: "CIEL" },
        ],
      },
    ];
    dispatch(setFiltrosPrestacionesSel(filtros));
  } catch (e) {
    trace.error("doGetFiltrosPrestacionesPes", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};
export const doGetPrestaciones = (filtros, reload = false) => async (dispatch) => {
  if (!filtros) dispatch(loading(true));
  try {
    let data = store.getState().mantenedorPrestacionesSel.listaPrestacionesSel;
    if (reload) {
      data = [];
    }
    let message;
    if (!data.length) {
      const request = await getPrestaciones();
      if (request.status === 200) {
        data = await request.json();
        dispatch(setListaPrestacionesSel(data));
        dispatch(showMessageApi(message, request));
      } else {
        const result = await request.json();
        dispatch(showMessageApi(message, request, result));
      }
    }

    if (filtros) {
      const newData = filterData(data, filtros);
      dispatch(setListaPrestacionesSelFiltradas(newData));
    }
  } catch (e) {
    trace.error("doGetPrestaciones", e);
    dispatch(showToastError());
  }
  if (!filtros) dispatch(loading(false));
};

export const doDeletePrestacionSel = (prestacion) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;
    const request = await deletePrestacion(prestacion.Id);

    if (request.status === 200) {
      message = `Se ha eliminado la prestación ${prestacion.Description}.`;
      dispatch(openCloseModalEliminarPrestacionSel(false, {}));
      dispatch(doGetPrestaciones(null, true));
      dispatch(showMessageApi(message, request));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doDeletePrestacionSel", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doAddPrestacion = (newRow) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const data = {};
    data.Description = newRow.Description;
    data.ExamTypeId = newRow.ExamTypeId;
    data.Code = newRow.Code;
    data.Active = !!newRow.Status;
    let message;

    const request = await createPrestacion(data);

    if (request.status === 200) {
      message = `Se ha agregado la prestación ${newRow.Description}.`;
      dispatch(doGetPrestaciones(null, true));
      dispatch(openCloseModalEditarPrestacionesSel(false, {}, false));
      dispatch(showMessageApi(message, request));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doAddPrestacion", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doUpdatePrestacion = (editedRow) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const data = {};
    data.ExamId = editedRow.Id;
    data.Description = editedRow.Description;
    data.ExamTypeId = editedRow.ExamTypeId;
    data.Code = editedRow.Code;
    data.Active = !!editedRow.Status;
    let message;
    const request = await updatePrestacion(data);
    if (request.status === 200) {
      message = `Se ha editado el prestación ${editedRow.Description}.`;
      dispatch(openCloseModalEditarPrestacionesSel(false, {}, false));
      dispatch(openCloseModalDesactivarPrestacionSel(false, {}, false));
      dispatch(doGetPrestaciones(null, true));
      dispatch(showMessageApi(message, request));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doUpdatePrestacion", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};
